/// <amd-module name="Artifacts/Root/routing/Constants" />
/**
 * Route constants file stores listing of all avaliable routes for the extension.
 * All routes are stored centrally for easier navigation between the views.
 *
 * Route strings may have url parameters (:parameter), for example
 * path /feed/1234-1234-1234/ will match /feed/:feedId/ route string.
 *
 * feedIdentifier parameter supports either feed name or feed ID.
 */

/**
 * Feed page routes
 */
export const feedHubRoute = "/feed/:feedIdentifier?";

/**
 * Settings routes
 */
export const settingsRoute = "/feed/:feedIdentifier/settings";
export const detailsSettingsRoute = "/feed/:feedIdentifier/settings/feed";
export const permissionsSettingsRoute = "/feed/:feedIdentifier/settings/permissions";
export const viewsSettingsRoute = "/feed/:feedIdentifier/settings/views";
export const upstreamsSettingsRoute = "/feed/:feedIdentifier/settings/upstreams";

/**
 * Package details routes
 */
export const packageDetails = "/feed/:feedIdentifier/:protocol/:packageName/:tabId?/:version?";
// This route is required for the tabbed router. With required tabId and optional version, useParams
// can retrieve the version part and preserve it when navigating between tabs
export const packageDetailsAnyTab = "/feed/:feedIdentifier/:protocol/:packageName/:tabId/:version?";
export const packageDetailsOverview =
  "/feed/:feedIdentifier/:protocol/:packageName/overview/:version?";
export const packageDetailsVersions =
  "/feed/:feedIdentifier/:protocol/:packageName/versions/:version?";
export const packageDetailsSearchUpstreams =
  "/feed/:feedIdentifier/:protocol/:packageName/upstreams/:version?";

/**
 * Package Recycle Bin Routes
 */
export const packageRecycleBinHubRoute = "/feed/:feedIdentifier/recycleBin/";

/**
 * Connect to Feed routes
 */
export const connectToFeed = "/feed/:feedIdentifier/connect/:toolId?";
